<template>
  <v-list class="user-card pa-0 role-info">
    <v-list-tile avatar v-if="alreadySent">
      <v-list-tile-avatar color="grey" size="24">
        <img
          alt="Avatar"
          :src="folder.current_owner.avatar.url"
          v-if="folder.current_owner.avatar.url"
        >
        <span class="caption role-info-name" v-else>{{ acronym(folder.current_owner.name) }}</span>
      </v-list-tile-avatar>
      <v-tooltip top>
        <v-list-tile-content slot="activator">
          <v-list-tile-title class="body-1">{{ shortName(folder.current_owner.name) }}</v-list-tile-title>
          <v-list-tile-sub-title class="caption tooltip role-info-name">
            {{ truncateText(folder.current_owner.role.name) }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <div class="admin-unit-badges-container">
          <!-- Unidade principal -->
          <v-chip
            v-if="folder.current_owner && folder.current_owner.administrative_unit"
            x-small
            color="transparent"
            class="admin-unit-badge admin-unit-badge--main"
            :style="{
              color: getUnitColor(folder.current_owner.administrative_unit),
              borderColor: getUnitColor(folder.current_owner.administrative_unit)
            }"
          >
            {{ folder.current_owner.administrative_unit.abbreviation || folder.current_owner.administrative_unit.name }}
          </v-chip>

          <!-- Unidades adicionais -->
          <template v-if="folder.current_owner.administrative_units && folder.current_owner.administrative_units.length > 0">
            <v-chip
              v-for="unit in getFilteredAdminUnits(folder.current_owner.administrative_units, folder.current_owner.administrative_unit ? folder.current_owner.administrative_unit.id : null)"
              :key="unit.id"
              x-small
              color="transparent"
              class="admin-unit-badge admin-unit-badge--extra"
              :style="{
                color: getFolderTypeColor(unit),
                borderColor: getFolderTypeColor(unit)
              }"
            >
              {{ unit.abbreviation || unit.name }}
            </v-chip>
          </template>
        </div>
        <br>
        <div class="role-info">
          <span class="role-info-name">{{ folder.current_owner.role.name }}</span>
        </div>
      </v-tooltip>

    </v-list-tile>
    <v-list-tile v-else>
      <v-chip color="grey-lighten-2">
        Não Tramitado
      </v-chip>
    </v-list-tile>
  </v-list>
</template>

<script>
import acronym from '@/utils/acronym';
import shortName from '@/utils/short-name';
import {isNull, truncate} from 'lodash';
import adminUnitHandling from '@/mixins/admin-unit-handling';
import getColorByText from '@/assets/utils/colorByText';

export default {
  name: 'current-owner',
  mixins: [adminUnitHandling],
  props: ['folder'],
  data() {
    return {
      shortName,
    };
  },
  methods: {
    truncateText(text) {
      if (this.$vuetify.breakpoint.lgOnly) {
        return truncate(text, {length: 25});
      }
      if (this.$vuetify.breakpoint.xlOnly) {
        return truncate(text, {length: 50});
      }
      return truncate(text, {length: 15});
    },
    acronym(string) {
      return acronym(string);
    },
    alreadySent() {
      return !isNull(this.folder.last_transaction);
    },
    getFolderTypeColor(folderType) {
      if (!folderType) return '#000000';
      return getColorByText(folderType.name);
    },
  },
  computed: {
    folderNotReceivedClass() {
      if (this.folder.current_owner.id === this.user.id) {
        return 'folder-received';
      }
      return '';
    },
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>
<style scoped>
.tooltip {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 120px;
}

.role-info {
  width: 100%;

  .role-info-chip {
    height: auto;
    padding: 4px 8px;
    cursor: pointer;
    background-color: #f5f5f5;
    display: flex; /* Mudança crítica de inline-flex para flex */
    align-items: center;
    width: 100%;

    .v-avatar {
      flex: 0 0 auto; /* Não encolher, não crescer, tamanho base */
      margin-right: 4px;
    }
  }
  .role-info-name {
    flex: 1 1 auto; /* Crescer e encolher conforme necessário */
    min-width: 0; /* Importante para permitir o truncamento */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    max-width: none !important; /* Sobrescreve o max-width do FolderCard */
  }
}

/* Classes admin-unit-badges-container e admin-unit-badge movidas para admin-unit-badges.scss */

.folder-received {
  background: #f2f2f2 !important;
}

.user-card {
  background: transparent;
}

/* Força o estilo do badge mesmo com Vuetify */
</style>



// WEBPACK FOOTER //
// src/components/inbox/CurrentOwner.vue